import React, { Children } from 'react';
import { motion } from 'framer-motion';
const features = [{
  label: 'Tomo 1',
  desc: 'Por qué el balanceado comercial daña a tu perro y tu gato'
}, {
  label: 'Tomo 2',
  desc: 'Plan de alimentación natural para perros (por edad, tamaño y raza)'
}, {
  label: 'Tomo 3',
  desc: 'Plan de alimentación natural para gatos (necesidades específicas)'
}, {
  label: 'Bono 1',
  desc: 'Recetario para perros — 20 recetas caseras paso a paso'
}, {
  label: 'Bono 2',
  desc: 'Recetario para gatos — 20 recetas caseras paso a paso'
}, {
  label: 'Bono 3',
  desc: 'Alimentos prohibidos + guía de suplementos naturales'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function WhatsIncluded() {
  return <section id="incluye" className="bg-brand-darkgreen py-24 px-6" data-id="element-76" data-mp="1whp6fnxwqrmv">
      <div className="max-w-5xl mx-auto" data-id="element-77" data-mp="1whxhdaagzmvf">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-[2rem] md:text-[2.4rem] text-white text-center mb-16 leading-tight" data-id="element-78" data-mp="1riuenwhypsqm">
          Todo lo que recibís al instante
        </motion.h2>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-79" data-mp="2ahghbft4nrwn">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className="bg-white/5 border border-white/20 rounded-2xl p-6 flex items-start gap-4 hover:bg-white/10 transition-colors duration-300" data-id="element-80" data-mp="2k8krm27uyol5" data-mpi={index}>
              <span className="text-2xl shrink-0 mt-1" data-id="element-81" data-mp="2u6qryfe0nmnw">✅</span>
              <div data-id="element-82" data-mp="318w0h2zwbmg4">
                <span className="text-brand-mint font-bold text-sm uppercase tracking-wider block mb-2" data-id="element-83" data-mp="319f9fu7kj0i0">
                  {feature.label}
                </span>
                <p className="text-white/70 leading-relaxed" data-id="element-84" data-mp="3b6tmdjua975k">{feature.desc}</p>
              </div>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex justify-center" data-id="element-85" data-mp="3fyldpwl9jgwr">
          <button type="button" onClick={() => document.getElementById('comprar')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-brand-orange text-white font-bold px-8 py-4 rounded-full shadow-lg text-center inline-flex items-center gap-2 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#d66e2d] hover:shadow-xl" data-id="element-86" data-mp="3tymhbjswx2fx">
            <span className="text-xl" data-id="element-87" data-mp="ln8rhvrifxqk">📱</span>
            <span data-id="element-88" data-mp="lo20l3dxyzbv">+ App digital de porciones y tracker semanal — GRATIS</span>
          </button>
        </motion.div>
      </div>
    </section>;
}